// import "./App.css";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./utils/ScrollToTopUtils";
import { LoaderProvider } from "./context/LoaderContext";
import { SiteConfigProvider } from "./context/SiteConfigContext";
import AnimatedRoutes from "./routes/AnimatedRoutes";
import { ToastContainer } from "react-toastify";
import { CartProvider } from "./context/CartContext";
import { HelmetProvider } from "react-helmet-async";
import PageLoader from "./context/PageLoader";
import { Suspense, useEffect, useState } from "react";
import { CategoryProvider } from "./context/CategoryContext";
// import FloatingIcon from "./components/FloatingIcon";
import { isCookieEnabled } from "./utils/cookieCheck";
import CookiePopup from "./components/CookiePopup";

function App() {
  return (
    <>
      <HelmetProvider>
        <CartProvider>
          <CategoryProvider>
            <SiteConfigProvider>
              <LoaderProvider>
                <BrowserRouter>
                  <ScrollToTop />

                  <Suspense fallback={<PageLoader />}>
                    {/* <CookiePopup /> */}
                    <AnimatedRoutes />
                  </Suspense>
                  {/* <FloatingIcon /> */}
                </BrowserRouter>
              </LoaderProvider>
            </SiteConfigProvider>
          </CategoryProvider>
        </CartProvider>
      </HelmetProvider>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;
